import {
  CreateTagRequest,
  DeleteTagRequest,
  DeleteTagResponse,
  Tag,
  CreateNamespaceRequest,
  Namespace,
  CreateEntityTagRequest,
  ChangeTagPercentageRequest,
  ChangeTagPercentageResponse,
  WipeTagRequest,
  WipeTagResponse,
  QueryNamespaceRequest,
  QueryNamespaceResponse,
} from '@weave/schema-gen-ts/dist/apis/api/wetags/v1/api.pb';
import { useMutation, UseMutationOptions } from 'react-query';
import {
  createNamespace,
  createTag,
  deleteTag,
  createEntityTag,
  changeTagPercentage,
  wipeTag,
  queryNamespace,
} from './api';

export const useCreateTagMutation = (
  options?: UseMutationOptions<Tag, Error, CreateTagRequest>
) => {
  return useMutation({
    mutationFn: (request: CreateTagRequest) => createTag(request),
    ...options,
  });
};

export const useDeleteTagMutation = (
  options?: UseMutationOptions<DeleteTagResponse, Error, DeleteTagRequest>
) => {
  return useMutation({
    mutationFn: (request: DeleteTagRequest) => deleteTag(request),
    ...options,
  });
};

export const useCreateNamespaceMutation = (
  options?: UseMutationOptions<Namespace, Error, CreateNamespaceRequest>
) => {
  return useMutation({
    mutationFn: (request: CreateNamespaceRequest) => createNamespace(request),
    ...options,
  });
};

export const useCreateEntityTagMutation = (
  options?: UseMutationOptions<void, Error, CreateEntityTagRequest>
) => {
  return useMutation({
    mutationFn: (request: CreateEntityTagRequest) => createEntityTag(request),
    ...options,
  });
};

export const useChangeTagPercentageMutation = (
  options?: UseMutationOptions<
    ChangeTagPercentageResponse,
    Error,
    ChangeTagPercentageRequest
  >
) => {
  return useMutation({
    mutationFn: (request: ChangeTagPercentageRequest) => changeTagPercentage(request),
    ...options,
  });
};

export const useWipeTagMutation = (
  options?: UseMutationOptions<WipeTagResponse, Error, WipeTagRequest>
) => {
  return useMutation({
    mutationFn: (request: WipeTagRequest) => wipeTag(request),
    ...options,
  });
};

export const useQueryNamespaceMutation = (
  options?: UseMutationOptions<QueryNamespaceResponse, Error, QueryNamespaceRequest>
) => {
  return useMutation({
    mutationFn: (request: QueryNamespaceRequest) => queryNamespace(request),
    ...options,
  });
};
